import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AvanceProcesalService } from '../../../services/avance-procesal.service';
import { AvanceProcesalDto } from '../../../dto/avance-procesal/avance-procesal.dto';
import { TableColumn } from '../../../dto/util/table-column';
import { UtilService } from '../../../services/util.service';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-detalle-avance-procesal',
  templateUrl: './detalle-avance-procesal.component.html',
  styleUrl: './detalle-avance-procesal.component.scss',
})
export class DetalleAvanceProcesalComponent implements OnInit, OnDestroy {
  expedienteId = 0;
  avanceProcesalList: AvanceProcesalDto[] = [];
  columns: TableColumn[] = [];
  pageSize = 5;
  totalPages = 0;
  currentPage = 1;
  private showComponents = false;
  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  entidadId = 0;
  // Multilenguaje
  tableText: any = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private avanceProcesalService: AvanceProcesalService,
    private utilService: UtilService,
    private translate: TranslateService
  ) {
    this.route.params.subscribe(params => {
      this.expedienteId = params['expedienteId'];
      this.entidadId = params['entidadId'];
    });
    // Multilenguaje
    this.translate.stream('detalle-avance-procesal').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      this._initColumns();
    });
  }

  ngOnInit(): void {
    this._getAvanceProcesalList(this.expedienteId);
    this.utilService.watch().subscribe(val => {
      this.showComponents = val;
    });
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: 'Consulta de solicitudes',
      descripcionPantalla:
        'En esta pantalla usted podrá visualizar las solicitudes que ha realizado a ' +
        'la entidad sobre el expediente',
      pasos: [],
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
  }

  private _getAvanceProcesalList(expedienteId: number) {
    this.avanceProcesalService
      .getAvanceProcesalByUserAndExpediente(expedienteId)
      .subscribe(response => {
        this.avanceProcesalList = response;
        this._initColumns();
      });
  }

  private _initColumns() {
    this.columns = [
      {
        field: 'Fecha_solicitud',
        title: this.tableText['fecha-solicitud'],
        type: 'date',
        pipe: 'dd/MM/yyyy',
        filterable: false,
        sortable: false,
      },
      {
        field: 'Asunto',
        title: this.tableText['asunto'],
        type: 'text',

        filterable: false,
        sortable: false,
        accion: (item: AvanceProcesalDto) => {
          this.router.navigate(
            [
              `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}/solicitudes/anexos/${item.Id}`,
            ],
            { state: { item } }
          );
        },
      },
    ];
  }

  ngOnDestroy(): void {
    if (this.showComponents) {
      this.utilService.show();
    } else {
      this.utilService.hide();
    }
  }
}
